import { useEffect, useState } from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { BiExport } from 'react-icons/bi';
import ConversationService from '../../services/conversation.service';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import CustomTable from '../../components/CustomTable';
import Paper from '../../components/Paper';
import tableColumnMetadata from './table.metadata';
import { format } from 'date-fns';
import { useNavigate } from 'react-router-dom';

const conversationService = new ConversationService();

const ConversationReport = () => {
  const initialPagination = { page: 1, pageSize: 10, pageCount: 1, totalCount: 0 };
  const [conversations, setConversations] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState(initialPagination);
  const navigate = useNavigate();

  const [dateRange, setDateRange] = useState<[Date | null, Date | null]>([new Date(), new Date()]);
  const [startDate, endDate] = dateRange;

  useEffect(() => {
    const fetchConversations = async () => {
      setLoading(true);

      const formattedStartDate = startDate ? format(startDate, 'dd/MM/yyyy') : '';
      const formattedEndDate = endDate ? format(endDate, 'dd/MM/yyyy') : '';

      try {
        const response = await conversationService.listConversations(
          formattedStartDate,
          formattedEndDate,
          pagination.pageSize,
          pagination.page
        );

        const updatedConversations = response.data.data.map((conversation: any) => ({
          ...conversation,
          nameTicket: conversation.ticket ? 'Si' : 'No'
        }));

        setConversations(updatedConversations);
        setPagination(response.data.pagination);
      } catch (error) {
        console.error('Error fetching conversations:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchConversations();
  }, [pagination.page, startDate, endDate]);

  const handleFooterClick = (value: number) => {
    const newPage = pagination.page + value;
    if (newPage >= 1 && newPage <= pagination.pageCount) {
      setPagination((prev) => ({ ...prev, page: newPage }));
    }
  };

  const handleClickRow = (conversation: any) => {
    navigate(`./${conversation._id}`);
  };

  const footerProps = {
    onClick: handleFooterClick,
    pagination,
    loading
  };

  const handleExportClick = async () => {
    const formattedStartDate = startDate ? format(startDate, 'dd/MM/yyyy') : '';
    const formattedEndDate = endDate ? format(endDate, 'dd/MM/yyyy') : '';

    try {
      const response = await conversationService.exportConversations(
        formattedStartDate,
        formattedEndDate
      );

      const blob = new Blob([response.data], { type: 'application/vnd.ms-excel' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'conversations_report.xlsx');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error('Error exporting conversations:', error);
    }
  };

  return (
    <Paper>
      <Row className="mb-2">
        <Col className="d-flex m-auto">
          <span>Reporte de Conversaciones</span>
        </Col>
        <Col xs={5} className="d-flex justify-content-end">
          <Button variant="outline-primary" onClick={handleExportClick}>
            <BiExport className="button-icon" />
            Exportar
          </Button>
        </Col>
      </Row>

      <Row className="mb-3">
        <Col xs={8}>
          <span>Seleccionar rango de fechas: </span>
          <DatePicker
            selectsRange
            startDate={startDate}
            endDate={endDate}
            onChange={(update: [Date | null, Date | null]) => setDateRange(update)}
            placeholderText="Seleccionar rango de fechas"
            dateFormat="dd/MM/yyyy"
            className="form-control"
          />
        </Col>
      </Row>

      <Row className="mt-1">
        <Col>
          <CustomTable
            data={conversations}
            columnsMetadata={tableColumnMetadata}
            footerProps={footerProps}
            loading={loading}
            onClickRow={handleClickRow}
          />
        </Col>
      </Row>
    </Paper>
  );
};

export default ConversationReport;
